import { supabase } from '../../config/supabase';

/**
 * Subscribe to real-time job_production updates
 * @param {string} companyId - The company ID (not used for job_production, but kept for consistency)
 * @param {Function} callback - Callback function for updates
 * @returns {Object} Supabase channel subscription
 */
export const subscribeToProductionUpdates = (companyId, callback) => {
    const channel = supabase
        .channel(`job-production-changes`)
        .on(
            'postgres_changes',
            {
                event: '*',
                schema: 'public',
                table: 'job_production'
            },
            callback
        )
        .subscribe();

    return channel;
};

/**
 * Subscribe to real-time job updates
 * @param {string} companyId - The company ID
 * @param {Function} callback - Callback function for updates
 * @returns {Object} Supabase channel subscription
 */
export const subscribeToJobUpdates = (companyId, callback) => {
    const channel = supabase
        .channel(`jobs-changes-${companyId}`)
        .on(
            'postgres_changes',
            {
                event: '*',
                schema: 'public',
                table: 'jobs',
                filter: `company_id=eq.${companyId}`
            },
            callback
        )
        .subscribe();

    return channel;
};

/**
 * Unsubscribe from job updates
 */
export const unsubscribeFromJobUpdates = async (channel) => {
    if (channel) {
        await supabase.removeChannel(channel);
    }
};
